import React from 'react';
import { Link } from 'react-router-dom';
import ObfuscatedEmail from '../components/ObfuscatedEmail';
import '../styles/Refund.css';

const Refund = () => {
  return (
    <div className="refund-container policy-portal">
      <div className="refund-header">
        <h1>환불·결제 정책</h1>
        <p>
          미라이쥬쿠는 정보 포털(가이드·루트 파인더·공식 자료), 선택적 90분 컨설팅,
          연간 시즌패스를 제공합니다. 온라인 강의 신규 판매는 중단되었습니다.
        </p>
      </div>

      <div className="refund-content">
        <section className="refund-section">
          <h2>1. 현재 판매 상태</h2>
          <ul>
            <li>
              <strong>판매 중:</strong> 90분 루트 컨설팅 (PayPal 또는 계좌 이체 · 일정 확정 후
              메일 안내) — <Link to="/consulting">신청</Link>
            </li>
            <li>
              <strong>판매 중:</strong> 입시 시즌패스 (연 1회 · 39,000원, PayPal 또는 계좌
              이체 · 신청 후 메일 안내) — <Link to="/pass">신청</Link>
            </li>
            <li>
              <strong>판매 중단:</strong> 온라인 강의·수강 신청·LMS 패키지
            </li>
            <li>
              사이트 본문(가이드·체크리스트·캘린더·무료 시즌 알림 등)은 정보 안내용이며,
              열람 자체에는 결제가 없습니다.
            </li>
          </ul>
        </section>

        <section className="refund-section">
          <h2>2. 90분 컨설팅 (신규)</h2>
          <ul>
            <li>결제 수단: PayPal 또는 계좌 이체 (일정 확정 후 메일 안내, 사이트에 계좌번호 미게시)</li>
            <li>결제 전·일정 확정 전 취소: 결제 없음 → 별도 환불 없음</li>
            <li>결제 후 · 세션 시작 48시간 전까지 취소: 전액 환불 검토</li>
            <li>세션 시작 48시간 이내 취소·노쇼: 원칙적으로 환불 불가 (운영자 귀책·불가항력은 예외 검토)</li>
            <li>세션 완료 후: 환불 불가 (요약 메모 제공 범위까지 포함)</li>
            <li>일정 변경: 세션 48시간 전까지 1회에 한해 협의 가능</li>
          </ul>
          <p>
            자세한 범위(포함·미포함)는 <Link to="/consulting">컨설팅 신청</Link> 페이지를
            기준으로 합니다. 합격·장학금 수혜는 보장하지 않습니다.
          </p>
        </section>

        <section className="refund-section">
          <h2>3. 입시 시즌패스</h2>
          <ul>
            <li>결제 수단: PayPal 또는 계좌 이체 (신청 접수 후 메일로 안내, 사이트에 계좌번호 미게시)</li>
            <li>결제 전 취소: 결제 없음 → 별도 환불 없음</li>
            <li>결제 후 · 액션팩/패스 메일 최초 발송 전: 전액 환불 검토</li>
            <li>액션팩·패스 메일 제공 후: 원칙적으로 환불 불가 (디지털 상품)</li>
            <li>유효 기간: 2026 입시 시즌패스(해당 연도 시즌 안내 범위)</li>
          </ul>
          <p>
            자세한 범위는 <Link to="/pass">시즌패스</Link> 페이지를 기준으로 합니다.
            강의가 아니며, 합격·장학금 수혜는 보장하지 않습니다.
          </p>
        </section>

        <section className="refund-section">
          <h2>4. 과거 온라인 강의 환불</h2>
          <p>예전에 결제한 강의가 있을 때의 처리 기준입니다. 신규 강의 결제는 받지 않습니다.</p>
          <ul>
            <li>결제일로부터 7일 이내, 진도율 10% 이하: 전액 환불 검토</li>
            <li>결제일로부터 7일 이내, 진도율 10% 초과 ~ 50% 이하: 결제 금액의 50% 환불 검토</li>
            <li>진도율 50% 초과 또는 결제일 7일 초과: 원칙적으로 환불 불가</li>
          </ul>
          <p>중대한 서비스 하자가 확인되면 위 기준과 별도로 검토할 수 있습니다.</p>
        </section>

        <section className="refund-section">
          <h2>5. 과거 컨설팅(레거시) 결제</h2>
          <p>
            현재 상품(90분·계좌 입금)과 다른, 과거에 결제했던 컨설팅이 있는 경우입니다.
          </p>
          <ul>
            <li>서비스 시작 전 취소: 전액 환불 검토</li>
            <li>초기 상담 이후: 진행 단계에 따라 일부 환불 또는 불가</li>
          </ul>
        </section>

        <section className="refund-section">
          <h2>6. 신청 방법</h2>
          <ul>
            <li>이메일: <ObfuscatedEmail /></li>
            <li>필요 정보: 결제일(또는 입금일), 금액, 상품명, 환불 사유, 환불 계좌</li>
          </ul>
          <p>접수 후 영업일 기준 3~5일 내 검토합니다. 카드 환불은 카드사 일정에 따릅니다.</p>
        </section>

        <section className="refund-section">
          <h2>7. 관련 페이지</h2>
          <p>
            <Link to="/consulting">컨설팅 신청</Link>
            {' · '}
            <Link to="/pass">시즌패스</Link>
            {' · '}
            <Link to="/dashboard">이전 수강 내역(마이페이지)</Link>
            {' · '}
            <Link to="/courses">강의 아카이브</Link>
          </p>
        </section>

        <div className="refund-date">
          <p>본 정책 안내는 2026년 7월 31일 기준입니다. 관련 법령이 우선합니다.</p>
        </div>
      </div>
    </div>
  );
};

export default Refund;
